/**
 * @file Homepage Gradient Banner.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Gradient Banner component.
 */
const vHpGradientBanner = () => {
	const hpGradientBanner = document.querySelector('.v-hp-gradient-banner');

	if (!hpGradientBanner) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);
	// const mm = gsap.matchMedia();
	const logos = hpGradientBanner.querySelectorAll('.v-hp-gradient-banner__logo');
	const logosTl = gsap.timeline({
		repeat: -1,
		paused: true,
	});

	[...logos].forEach((logo, i) => {
		const {name} = logo.dataset;
		const fillable = logo.querySelectorAll('.v-hp-gradient-banner__logo-fillable');
		const unstrokeable = logo.querySelectorAll('[class*="--unstrokeable"]');
		const tl = gsap.timeline()
		.from(logo, {
			scale: .8,
			duration: .75,
			opacity: 0,
			onStart: () => {
				logo.parentElement.classList.remove('hide');
			},
		})
		.addLabel(`start-${name}-fill`)
		.fromTo(fillable, { fill: 'rgba(255, 255, 255, 0)' }, {
			fill: 'rgba(255, 255, 255, 1)',
			duration: 1,
		});

		if (unstrokeable.length) {
			tl.to(unstrokeable, { stroke: 'rgba(255, 255, 255, 0)' }, `<start-${name}-fill`);
		}

		tl.to(logo, {
			scale: 1.1,
			yoyo: true,
			repeat: 1,
			duration: .25,
		})
		.to(logo, {
			delay: 0.25,
			duration: .75,
			scale: 1.2,
			opacity: 0,
			onComplete: () => {
				logo.parentElement.classList.add('hide');
			},
		});

		logosTl.add(tl, i > 0 ? '>-=5%' : null);
	});

	const gradient = hpGradientBanner.querySelector('.v-hp-gradient-banner__gradient');
	const logoList = hpGradientBanner.querySelector('.v-hp-gradient-banner__logo-list');
	const media = hpGradientBanner.querySelector('.v-hp-gradient-banner__media');
	const mediaBg = hpGradientBanner.querySelector('.v-hp-gradient-banner__media-bg');

	gsap.timeline({
		scrollTrigger: {
			trigger: hpGradientBanner,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true,
			onUpdate: ({progress}) => {
				if (progress > .8) {
					logoList.classList.add('v-hp-gradient-banner__logo-list--visible');
					logosTl.play(0);
				} else {
					logoList.classList.remove('v-hp-gradient-banner__logo-list--visible');
					logosTl.pause();
				}
			},
		},
		defaults: {
			ease: 'power1.inOut',
		},
	})
	.addLabel('start')
	.from(gradient, {
		yPercent: 10,
		scale: .9,
	}, 'start')
	.from(mediaBg, {
		xPercent: 30,
	}, 'start')
	.from(media, {
		xPercent: 12.5,
	}, 'start');
};

export default vHpGradientBanner;
